import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { auth, commonStore, betsStore, accountStore, fantasyCricketStore, walletStore,seoStore, mutations, actions } from '@template/utils';

export default createStore({
  state: {},
  mutations,
  actions,
  modules: { auth, commonStore, betsStore, accountStore, fantasyCricketStore, walletStore, seoStore },
  plugins: [createPersistedState({
    key:'sd:site'
  })]
});